import { render, staticRenderFns } from "./AddOns.vue?vue&type=template&id=6f480389&scoped=true&"
import script from "./AddOns.vue?vue&type=script&lang=js&"
export * from "./AddOns.vue?vue&type=script&lang=js&"
import style0 from "./AddOns.vue?vue&type=style&index=0&id=6f480389&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f480389",
  null
  
)

export default component.exports